import { el, mount, unmount } from 'redom';

import { stringToSVG } from 'utilities';

import SearchIconString from 'assets/images/search-menu-icon.svg?raw';

const SearchIcon = stringToSVG(SearchIconString);

class SearchBar {

  constructor() {

    this.onChange = null;
    this.searchTimeout = null;
    this.isSearching = false;

    this.searchIconElement = SearchIcon.cloneNode(true);
    this.spinner = el('ht-spinner', { size: 'small' });

    this.searchIcon = el('.search-icon-container', {
      onclick: function onClick() {
        this.searchInput.focus();
      }.bind(this)
    });
    this.searchIcon.appendChild(this.searchIconElement);

    this.searchInput = el('input.search-input', {
      type: 'text',
      placeholder: 'Search...',
      oninput: this.handleSearchInputChange.bind(this)
    });

    this.el = el('.search-bar', [
      this.searchIcon,
      this.searchInput
    ]);

  }

  setValue(value) {

    this.searchInput.value = value;

  }

  clear() {

    this.searchInput.value = '';

  }

  focus() {

    this.searchInput.focus();

  }

  setOnChange(onChange) {

    this.onChange = onChange;

  }

  showSpinner() {

    if (this.isSearching === true) {
      return;
    }

    this.isSearching = true;
    this.searchIcon.innerHTML = '';
    mount(this.searchIcon, this.spinner);

  }

  hideSpinner() {

    if (this.isSearching === false) {
      return;
    }

    this.isSearching = false;
    this.searchIcon.innerHTML = '';
    this.searchIcon.appendChild(this.searchIconElement);

  }

  handleSearchInputChange(event) {

    const searchTerm = event.target.value;

    if (this.searchTimeout !== null) {
      clearTimeout(this.searchTimeout);
    }

    this.searchTimeout = setTimeout(function executeChange() {
      if (this.onChange !== null) {
        this.onChange(searchTerm);
      }
    }.bind(this), 300);

  }

  cleanup() {

    if (this.searchTimeout !== null) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = null;
    }

  }

}

export default SearchBar;